module.exports = __webpack_public_path__ + "media/images/profile-055a91979264664a1ee12b9453610d82.png";